import React from "react";
import { Link } from "react-router-dom";
import cancel from "./res/cancel.png";

function Cancel() {
  return (
    <>
      <div className="section">
        <div className="process-section cancel">
          <div className="process-img">
            <img src={cancel} alt="" />
          </div>
          <div style={{ textAlign: "center" }}>
            Order Cancelled Successfully
          </div>
          <div className="home">
            <Link to="/">Go Home</Link>
          </div>
        </div>
      </div>
    </>
  );
}

export default Cancel;
